import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { useParams } from "react-router-dom";
import axios from "axios";
import { SERVERADDRESS } from "../constants";
import { useSelector } from "react-redux";

const AdminStoreDetailPage = () => {
  const orders = useSelector((state) => state.orders);
  const items = useSelector((state) => state.items);

  const [activeTab, setActiveTab] = useState("Orders");

  const [arr, setArr] = useState([]);
  // console.log(orders, "orders");
  // console.log(items, "items");
  const params = useParams();
  const orderData = async () => {
    const { data } = await axios.post(
      `${SERVERADDRESS}/v1/store/getStoreById`,
      { _id: params.id }
    );
    setArr(data);
    console.log(data, "datadata");
  };

  useEffect(() => {
    orderData();
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-xl-12 col-12">
                <div className="card rounded-1 card-table">
                  <div className="card-header py-3">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">Store Informations</h5>
                        <p>
                          Store Name: <strong>{arr?.store?.name}</strong>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="container">
                    {/* Tabs */}
                    <div className="tabs">
                      <div
                        className={`tab ${
                          activeTab === "Orders" ? "active" : ""
                        }`}
                        onClick={() => handleTabClick("Orders")}
                      >
                        Orders
                      </div>
                      <div
                        className={`tab ${
                          activeTab === "Analytics" ? "active" : ""
                        }`}
                        onClick={() => handleTabClick("Analytics")}
                      >
                        Analytics
                      </div>
                      <div
                        className={`tab ${
                          activeTab === "Reviews" ? "active" : ""
                        }`}
                        onClick={() => handleTabClick("Reviews")}
                      >
                        Reviews
                      </div>
                      <div
                        className={`tab ${
                          activeTab === "Products" ? "active" : ""
                        }`}
                        onClick={() => handleTabClick("Products")}
                      >
                        Products
                      </div>
                    </div>

                    {/* Tab Content */}
                    {activeTab === "Orders" && (
                      <div className="orders">
                        {arr?.allOrder?.map((x, i) => {
                          return (
                            <div className="order-card" key={i}>
                              {/* <img
                            src="https://via.placeholder.com/80x100"
                            alt="Product Image"
                          /> */}
                              <div className="order-details">
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {/* {arr?.allOrder?.orderNo} */}
                                  <h3>ORDER# {x?.orderNo}</h3>
                                  <div className="badge-new">Created</div>
                                </div>
                                <p>Thursday, January 30th 2025</p>
                                {x?.itemsId?.map((y, index) => {
                                  return (
                                    <>
                                      <div key={index}>
                                        <p>
                                          {y?.name
                                            ? y?.name
                                            : `Product ${index + 1}`}{" "}
                                          - {y?.sellPrice} ${" "}
                                          <div className="order-status">
                                            <span className="quantity">
                                              x {y?.quantity}
                                            </span>
                                          </div>
                                        </p>
                                      </div>
                                    </>
                                  );
                                })}

                                <p>
                                  <strong>Total:</strong> {x?.totalAmount}$
                                </p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {activeTab === "Analytics" && (
                      <div className="analytics">
                        <div className="table-responsive">
                          <table className="table table-striped table-hover">
                            <thead className="thead-light">
                              <tr>
                                <th>Analysis</th>
                                <th>Comment</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Up</td>
                                <td>Rice was good and quick service</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {activeTab === "Reviews" && (
                      <div className="reviews">
                        <div className="table-responsive">
                          <table className="table table-striped table-hover">
                            <thead className="thead-light">
                              <tr>
                                <th>Id</th>
                                <th>From</th>
                                <th>On</th>
                                <th>Rating</th>
                                <th>Comment</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>122</td>
                                <td>Order by Abde Faisal</td>
                                <td>2/1/2025</td>
                                <td>4/5</td>
                                <td>Rice was good and quick service</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {activeTab === "Products" && (
                      <div className="products">
                        <div className="table-responsive">
                          <table className="table table-striped table-hover">
                            <thead className="thead-light">
                              <tr>
                                <th>Id</th>
                                {/* <th>Cover</th> */}
                                <th>Product Name</th>
                                <th>Price</th>
                                <th>In Stock</th>
                                <th>Rating</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {arr?.allItem?.map((x, i) => {
                                return (
                                  <tr key={i}>
                                    <td>122</td>
                                    {/* <td>img</td> */}
                                    <td>{x?.name}</td>
                                    <td>{x?.sellPrice}$</td>
                                    <td>In stock</td>
                                    <td>4(5)</td>
                                    <td>
                                      {x?.status === true ? (
                                        <a
                                          href="#"
                                          className="btn btn-sm btn-success"
                                          // onClick={openActiveModal}
                                        >
                                          Active
                                        </a>
                                      ) : (
                                        <a
                                          href="#"
                                          className="btn btn-sm btn-dark"
                                          // onClick={openActiveModal}
                                        >
                                          Deactivated
                                        </a>
                                      )}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminStoreDetailPage;
